/** A date for a table cell: day month year, or a dash when the backend does not provide it. */
export function formatDate(value?: number | string | null): string {
  if (value === undefined || value === null || value === '') return '—';
  const d = new Date(typeof value === 'number' ? value : Number.isNaN(Number(value)) ? value : Number(value));
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' });
}

/** The latest of several dates (ms or ISO), or undefined when none is known. */
export function latest(...values: (number | string | undefined | null)[]): number | undefined {
  const ms = values
    .filter((v): v is number | string => v !== undefined && v !== null && v !== '')
    .map((v) => (typeof v === 'number' ? v : Number.isNaN(Number(v)) ? Date.parse(v) : Number(v)))
    .filter((v) => !Number.isNaN(v));
  return ms.length ? Math.max(...ms) : undefined;
}

export const NO_DATE_HINT = 'Not provided by the Trustline API yet';

/** Most recently modified first (unknown dates last), then by name. */
export function byModifiedThenName<T>(modified: (x: T) => number | undefined, name: (x: T) => string) {
  return (a: T, b: T): number => (modified(b) ?? -Infinity) - (modified(a) ?? -Infinity) || name(a).localeCompare(name(b));
}
